import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore.js';

const ticketConversationActionStoreConfig = {
  id: 'ticketConversationAction',
  initialState: {
    notes: {
      isPublicNote: false
    },
    conversation: {
      conversationScope: null,
      selectedMailbox: null,
      isTriageConversation: false,
      to: null,
      cc: null,
      bcc: null
    }
  },
  methods: (set, get) => ({
    setIsPublicNote: (isPublicNote: boolean) => {
      set({ notes: { isPublicNote } });
    },
    setSelectedConversationMailbox: (selectedMailbox: any) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, selectedMailbox } });
    },
    resetNotesData: () => {
      set({ notes: { isPublicNote: false } });
    },
    setConversationCC: (cc: any) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, cc } });
    },
    setConversationTo: (to: any) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, to } });
    },
    setConversationBCC: (bcc: any) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, bcc } });
    },
    setConversationScope: (conversationScope: string) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, conversationScope } });
    },
    setIsTriageConversation: (isTriageConversation: boolean) => {
      const conversationData = get().conversation;
      set({ conversation: { ...conversationData, isTriageConversation } });
    },
    resetConversationData: () => {
      set({
        conversation: {
          to: null,
          selectedMailbox: null,
          cc: null,
          bcc: null,
          isPrivateChannel: false,
          isTriageConversation: false
        }
      });
    },
    resetSideConversationData: () => {
      set({ sideConversation: { selectedMailbox: null, cc: null, bcc: null } });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true,
    scope: 'global'
  }
};

const storeInstances = new Map();

// Function to create or get existing store instance
const createTicketConversationActionStore = (componentId) => {
  if (storeInstances.has(componentId)) {
    return storeInstances.get(componentId);
  }

  const config = {
    ...ticketConversationActionStoreConfig,
    id: `ticketConversationAction_${componentId}`
  };

  const storeInstance = createStore(config);
  storeInstances.set(componentId, storeInstance);
  return storeInstance;
};

// Custom hook to return appropriate store based on props
export const useTicketConversationActionStore = (props: {
  ticketId: string;
}) => {
  const { ticketId } = props;

  if (!ticketId) {
    throw new Error('ticketId and mode are required');
  }

  // Create component id using ticket id and mode suffix
  const finalComponentId = `${ticketId}_global_conversation}`;

  // For regular components, create/get unique instance based on componentId
  if (finalComponentId) {
    return createTicketConversationActionStore(finalComponentId);
  }

  return useTicketConversationActionStore;
};
